import { atom, RecoilState } from "recoil"
import { Message } from "../connector/type";

interface MessagesState {
  roomId: string;
  messages: Message[];
}

const messagesStateDefault: MessagesState = {
  roomId: 'square',
  messages: [],
}

const messagesState: RecoilState<MessagesState> = atom({
  key: 'messages',
  default: messagesStateDefault
});

export default messagesState;